import React from 'react';
import { useMeasurementUnitContext } from '../../../../contexts/measurementUnits/measurementUnit.tsx';

const MeasurementUnitHeader = () => {
    const { measurementUnit } = useMeasurementUnitContext()
    return (
        <h1>{measurementUnit.name ?? "Create measurement unit"}</h1>
    );
};

export default MeasurementUnitHeader;
